/** @format */

import React from "react";
import { formatMinuti, percentualeBarra, statoTotali, testoDelta, TUnita } from "../format";
import { Totali } from "../styles";

interface Props {
  assegnati: number;
  previsti: number;
  delta: number;
  unita: TUnita;
  oltreContratto?: boolean;
  nota?: string;
}

/** Assegnate di previste, barra e delta con colore e testo (il colore non è mai l'unico segnale). */
export const BloccoTotali = ({
  assegnati,
  previsti,
  delta,
  unita,
  oltreContratto = false,
  nota,
}: Props): JSX.Element => {
  const stato = statoTotali(delta, oltreContratto);

  return (
    <Totali>
      <div className="numeri">
        <strong>{formatMinuti(assegnati, unita)}</strong>
        <span className="di">di {formatMinuti(previsti, unita)}</span>
      </div>
      <div className="barra" aria-hidden="true">
        <span className={stato} style={{ width: `${percentualeBarra(assegnati, previsti)}%` }} />
      </div>
      <div className={`delta ${stato}`}>{testoDelta(delta, unita, oltreContratto)}</div>
      {nota && <div className="nota">{nota}</div>}
    </Totali>
  );
};
